/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./editSource.vue?vue&type=template&id=640c64f2&scoped=true"
import script from "./editSource.vue?vue&type=script&lang=js"
export * from "./editSource.vue?vue&type=script&lang=js"
import style0 from "./editSource.vue?vue&type=style&index=0&id=640c64f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640c64f2",
  null
  
)

export default component.exports